import React from 'react'
import environment from '../../environment';
import styled from "styled-components";

const Wrapper = styled.div`
  grid-area: banner;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color:#D40000;
  padding: 8px;
  height: fit-content;
`;
const Warning = styled.p`
  color: white;
  font-weight: bold;
  padding:0;
  margin:0;
  margin-right: 16px;
  font-size: 1rem;
`
const Message = styled.p`
  color: white;
  padding:0;
  margin:0;
  font-size: .75rem;
  font-weight: 500;
`
const Link = styled.a`
  padding: 2px 6px;
  background-color: white;
  color: #1380B1;
  border-radius: 2px;
  border: 1px solid #dfdfdf;
  font-size: .75rem;
  font-weight: 500;
  margin:0;
  margin-left: 16px;
  &:hover{
    background-color: white;
    color: #1380B1;
  }
`
const IconSvg = styled.svg`
  margin-right: 4px;
  
`

export default function DevelopmentBanner() {
  return (
    <Wrapper>
      <Warning>
        <IconSvg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.7625 1.63438C7.8125 1.55 7.90312 1.5 8 1.5C8.09688 1.5 8.1875 1.55 8.2375 1.63438L14.4344 11.8125C14.4781 11.8844 14.5 11.9656 14.5 12.0469C14.5 12.2969 14.2969 12.5 14.0469 12.5H1.95312C1.70312 12.5 1.5 12.2969 1.5 12.0469C1.5 11.9625 1.52187 11.8813 1.56562 11.8125L7.7625 1.63438ZM6.48125 0.853125L0.284375 11.0312C0.096875 11.3375 0 11.6875 0 12.0469C0 13.125 0.875 14 1.95312 14H14.0469C15.125 14 16 13.125 16 12.0469C16 11.6875 15.9 11.3375 15.7156 11.0312L9.51875 0.853125C9.19688 0.325 8.62187 0 8 0C7.37813 0 6.80312 0.325 6.48125 0.853125ZM9 10.5C9 10.2348 8.89464 9.98043 8.70711 9.79289C8.51957 9.60536 8.26522 9.5 8 9.5C7.73478 9.5 7.48043 9.60536 7.29289 9.79289C7.10536 9.98043 7 10.2348 7 10.5C7 10.7652 7.10536 11.0196 7.29289 11.2071C7.48043 11.3946 7.73478 11.5 8 11.5C8.26522 11.5 8.51957 11.3946 8.70711 11.2071C8.89464 11.0196 9 10.7652 9 10.5ZM8.75 4.75C8.75 4.33437 8.41562 4 8 4C7.58437 4 7.25 4.33437 7.25 4.75V7.75C7.25 8.16562 7.58437 8.5 8 8.5C8.41562 8.5 8.75 8.16562 8.75 7.75V4.75Z" fill="currentColor"/>
      </IconSvg>    
        Oops!
      </Warning>
      <Message>
        You're on the wrong page
        <Link href="https://www.caseparts.com">Go Home</Link>
      </Message>
    </Wrapper>
  );
}
